import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from '../page/page.component';

@Component({
    selector: 'completed',
    templateUrl: './completed.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PageComponent]
})
export class CompletedComponent {}
